module.exports = __webpack_public_path__ + "static/img/YNHT.f6c3816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bankInfoBg/YNHT.png
// module id = qMwh
// module chunks = 70